import { SET_SEARCH_PREFERENCES } from 'app/actions/types';
import { SearchPreferenceCookie } from 'src/react/shared/api/searchPreferenceCookie';

// The only preference fields anything reads out of Redux:
// useIsPanelOpenPreference takes the first, useAssetsLayout the other three,
// and useSearchPreferencesAdapter deserializes the slice for a single consumer
// that wants the grid layout. Everything else Rails sends -- the eight
// per-context scope fields especially -- has no reader here.
//
// Seeding only these keeps the scope preferences out of Redux entirely, so the
// BFF can own them without Redux being a second, silently-diverging copy. The
// banner flags are absent on purpose too: BannersAdapter reads them straight
// off the cookie and never from the store.
const SEEDED_PREFERENCES = [
  'refinement_panel_state',
  'search_grid_layout',
  'image_search_grid_layout',
  'film_search_grid_layout',
];

const seededOnly = (preferences = {}) =>
  SEEDED_PREFERENCES.reduce(
    (seeded, name) =>
      preferences[name] === undefined
        ? seeded
        : { ...seeded, [name]: preferences[name] },
    {}
  );

export const searchPreferencesAvailable = (preferences) => ({
  type: SET_SEARCH_PREFERENCES,
  preferences: seededOnly(preferences),
});

export const setSearchPreference = (preference, value) => {
  const cookie = SearchPreferenceCookie.find();
  cookie[preference] = value;
  return {
    type: SET_SEARCH_PREFERENCES,
    preferences: {
      [preference]: value,
    },
  };
};

export const toggleFilterPanel = (currentValue) => {
  const preference = 'refinement_panel_state';
  const value = currentValue === 'open' ? 'closed' : 'open';
  return setSearchPreference(preference, value);
};

export const toggleGridLayout = (currentValue) => {
  const preference = 'search_grid_layout';
  const value = currentValue === 'fixed' ? 'mosaic' : 'fixed';
  return setSearchPreference(preference, value);
};
